import { useTranslation } from "react-i18next";
import { useResetPasswordMutation } from "../api/userAuthApi";
import { useMutationWithFeedback } from "../../../common/hooks/useMutationWithFeedback";
import type { ResetPasswordPayload } from "../types/userAuthApiTypes";

export const useResetPassword = () => {
  const { t } = useTranslation();
  const [resetPassword, result] = useResetPasswordMutation();

  const {
    trigger: handleResetPassword,
    isLoading,
    isSuccess,
  } = useMutationWithFeedback<{ message: string }, ResetPasswordPayload>({
    mutation: [resetPassword, result],
    loadingMessage: t(
      "feedback.user.resetPassword.loading",
      "Resetting password..."
    ),
    successMessage: t(
      "feedback.user.resetPassword.success",
      "Password reset successfully! You can now log in."
    ),
    errorMessages: {
      default: t(
        "feedback.user.resetPassword.error",
        "Could not reset password. Please try again."
      ),
      // Map both snake_case and kebab-case for robustness
      expired_key: t(
        "feedback.user.resetPassword.expiredKey",
        "This password reset link has expired."
      ),
      "expired-key": t(
        "feedback.user.resetPassword.expiredKey",
        "This password reset link has expired."
      ),
      invalid_key: t(
        "feedback.user.resetPassword.invalidKey",
        "This password reset link is invalid."
      ),
      "invalid-key": t(
        "feedback.user.resetPassword.invalidKey",
        "This password reset link is invalid."
      ),
      missing_params: t(
        "feedback.user.resetPassword.missingParams",
        "Missing required parameters."
      ),
      "missing-params": t(
        "feedback.user.resetPassword.missingParams",
        "Missing required parameters."
      ),
      weak_password: t(
        "user.validation.weakPassword",
        "Password must be at least 8 characters long and include an uppercase letter and a number."
      ),
      "weak-password": t(
        "user.validation.weakPassword",
        "Password must be at least 8 characters long and include an uppercase letter and a number."
      ),
    },
    successToastType: "success",
  });

  return {
    handleResetPassword,
    isLoading,
    isSuccess,
  };
};
